import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import './DownloadLink.scss';
import { DownloadModal } from 'ui/components';
import { FormattedMessage } from 'ui/i18n';

@observer
export default class DownloadLink extends Component {
	static propTypes = {
		promotionId: PropTypes.number.isRequired,
		name: PropTypes.string.isRequired,
	};

	@observable showDownloadModal = false;

	@action
	toggleModal() {
		this.showDownloadModal = !this.showDownloadModal;
	}

	render() {
		return (
			<div className="DownloadLink">
				<div
					className="DownloadLink__download"
					onClick={this.toggleModal.bind(this)}
				>
					<FormattedMessage id="leftSideMenu.downloadSoloDetails" />
				</div>
				<DownloadModal
					name={this.props.name}
					promotionId={this.props.promotionId}
					toggleModal={this.toggleModal.bind(this)}
					showDownloadModal={this.showDownloadModal}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DownloadLink/index.js